// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "7ae4a54236c9aa82c3a0835b1237e346" + ".js";
};